import type { ComponentTheme } from '../types/component-theme';

export default {
    slots: {
        backdrop:
            'fixed top-0 left-0 z-2 h-screen w-screen bg-(--slate-overlay-alpha-45) ' +
            '[backdrop-filter:blur(0.375rem)_saturate(1.2)] transform-gpu will-change-[opacity]',
        wrapper:
            'pointer-events-none fixed top-0 left-0 z-3 flex h-full w-full flex-col overflow-x-hidden ' +
            'overflow-y-auto bg-transparent py-7 outline-0',
        content:
            'relative my-auto mx-auto flex w-full max-w-175 shrink-0 flex-col overflow-hidden pointer-events-auto ' +
            'rounded-(--border-radius-xl) border-[0.063rem] border-solid border-(--white-alpha-70) ' +
            'bg-(image:--surface-modal-bg) outline-0 transform-gpu backface-hidden contain-[layout_paint_style] ' +
            'will-change-[opacity,transform] before:absolute before:top-0 before:left-[8%] before:right-[8%] ' +
            'before:z-1 before:h-[0.063rem] ' +
            'before:bg-[linear-gradient(90deg,transparent,var(--shadow-light),transparent)] before:content-[""] ' +
            'before:pointer-events-none',
        header:
            'flex shrink-0 items-start justify-between border-b-[0.063rem] border-b-(--slate-muted-alpha-12) px-10 ' +
            'pt-9 pb-5',
        headerContent:
            'flex flex-1 flex-col gap-y-[0.35rem] pr-12 [&_h3]:m-0 [&_h3]:font-(family-name:--secondary-font) ' +
            '[&_h3]:text-[1.25rem] [&_h3]:font-extrabold [&_h3]:tracking-[-0.02em] ' +
            '[&_h3]:text-(--input-neumorphic-text) [&_p]:m-0 [&_p]:font-(family-name:--primary-font) ' +
            '[&_p]:text-[0.82rem] [&_p]:font-medium [&_p]:leading-normal [&_p]:text-(--text-light)',
        closeButton:
            'base-modal__close-btn flex h-8.5 w-8.5 items-center justify-center pl-[unset]! pr-[unset]! ' +
            '[&_.iconify]:size-4.5! [&:hover_.iconify]:scale-[0.975] [&:active_.iconify]:scale-[0.955]',
        body: 'relative flex-[1_1_auto] px-10 pt-5 pb-6 text-(--text-dark)',
        footer:
            'flex shrink-0 flex-wrap items-center justify-end gap-3 border-t-[0.063rem] ' +
            'border-t-(--slate-muted-alpha-12) px-10 pt-4 pb-9'
    }
} satisfies ComponentTheme;
